import { LinkContent } from '../../models/link.model';

interface Props {
    link?: LinkContent;
    children?: React.ReactNode;
}

export const GridVariantLinkDisplay = ({
    link,
    children,
}: Props): React.ReactElement<any, any> | null => {
    let className = 'd-flex h-100';

    if (!link) {
        return <div className={className}>{children}</div>;
    }

    className += ' content-link';

    return (
        <a href={link.url} className={className}>
            {children}
        </a>
    );
};
